import { actions as resourcesActions } from "containers/Resources/Resources.reducer";
import { LIST_ACTION_CONCURRENCY } from "containers/Resources/listActionConcurrency";
import { all, call, put } from "redux-saga/effects";

let activeListActions = 0;

function* updateListActionProgress(current, total, label) {
    yield put({
        type: resourcesActions.LIST_ACTION_PROGRESS_UPDATE,
        progress: { current, total, label },
    });
}

function* clearListActionProgress() {
    activeListActions = Math.max(0, activeListActions - 1);
    if (activeListActions === 0) {
        yield put({ type: resourcesActions.LIST_ACTION_PROGRESS_CLEAR });
    }
}

/**
 * Process resources in batches of LIST_ACTION_CONCURRENCY parallel saga workers.
 * @param {Array} resources
 * @param {string} label Progress label shown in the toolbar
 * @param {function*} processOne Generator (resource) => result
 */
export function* runBatchedListAction(resources, label, processOne) {
    const total = resources.length;
    const results = [];

    activeListActions += 1;

    try {
        if (total > 0) {
            yield* updateListActionProgress(0, total, label);
        }

        for (let start = 0; start < total; start += LIST_ACTION_CONCURRENCY) {
            const batch = resources.slice(start, start + LIST_ACTION_CONCURRENCY);
            const batchResults = yield all(batch.map((res) => call(processOne, res)));
            results.push(...batchResults);
            yield* updateListActionProgress(Math.min(start + batch.length, total), total, label);
        }

        return results;
    } finally {
        yield* clearListActionProgress();
    }
}
